export default __webpack_public_path__ + "762f03c68e7e2022a0beb11f71530901.png";